import React from 'react'
import { Link } from 'react-router'

export default React.createClass({
  render() {
    return <Link {...this.props} className="nav-link" activeClassName="active"/>
  }
})



// WEBPACK FOOTER //
// ./src/components/NavLink.js